import { render, staticRenderFns } from "./SensitiveContentAllowed.vue?vue&type=template&id=7928561a&"
import script from "./SensitiveContentAllowed.vue?vue&type=script&lang=ts&"
export * from "./SensitiveContentAllowed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports